import React, { useState } from "react";

import { Container, Row, Col } from "react-bootstrap";
import {IframeHomeUrl} from './../../../constants/constants'

export default function HomePage() {
  const [error, setError] = useState(null);

  const handleIframeLoadError = (e) => {
    console.error("Error al cargar el iframe debido a CSP o frame-ancestors.");    
    setError("No puedes ver este contenido aquí debido a restricciones del servidor");
  };

  return (
    <Container fluid className="d-flex flex-column"
      style={{
        marginTop:'10px',
        height:"calc(100vh - 70px)"
      }}
    >
          <iframe
            src={IframeHomeUrl}
            onLoad={handleIframeLoadError}
            onError={handleIframeLoadError}
            style={{
              height: "100%",
              width: "100%",
              border: "none"
            }}
            title="Iframe"
          ></iframe>
    </Container>
  );
}
